import { Injectable, OnDestroy } from '@angular/core';
import { SystemNoteList } from 'src/app/system-note/model/systemNoteList';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { SystemNoteEdit } from 'src/app/system-note/model/systemNoteEdit';

@Injectable({
  providedIn: 'root'
})
export class SystemNoteService implements OnDestroy
{
  private messagingLanguageChangedSubscription: Subscription;

  constructor(private http: HttpClient) { }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get systemNotes for grid list.
   */
  public getSystemNotesList(): Observable<SystemNoteList[]>
  {
    return this.http.get<SystemNoteList[]>('/system/notes/list');
  }

  /**
   * Delete a systemNote.
   *
   * @param id SystemNote id
   */
  public deleteSystemNote(id: number): Observable<SystemNoteList>
  {
    return this.http.delete<SystemNoteList>(`/system/note/${id}`);
  }

  /**
   * Get systemNote by id.
   *
   * @param id SystemNote id
   */
  public getSystemNoteById(id: number): Observable<SystemNoteEdit>
  {
    return this.http.get<SystemNoteEdit>(`/system/note/${id}`);
  }

  /**
   * Save a systemNote.
   *
   * @param data SystemNote to persit
   * @param isNew Indicate if this is a new or update
   * @param systemNoteId SystemNote id to update.
   */
  public saveSystemNote(data: any, isNew: boolean, systemNoteId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/system/note', data);
    }
    else
    {
      return this.http.put(`/system/note/${systemNoteId}`, data);
    }
  }
}
